export default __webpack_public_path__ + "static/media/dice.2ee0399f.png";